import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDetails = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 3q.825 0 1.412.588Q21 4.176 21 5v14q0 .825-.588 1.412A1.93 1.93 0 0 1 19 21H5q-.824 0-1.412-.588A1.93 1.93 0 0 1 3 19V5q0-.824.588-1.412A1.93 1.93 0 0 1 5 3zM5 19h14V5H5zm9-4v2H7v-2zm3-4v2H7v-2zm0-4v2H7V7z" })
});
export default SvgDetails;
